export default __webpack_public_path__ + "static/media/JEAN.ee722496.png";